import React from 'react';
import c from 'classnames';
import InputLabel from '../../lego/InputLabel';
import s from './FormElement.scss';
/**
 * Our standard form element layout with a slot above (`label`) and below (`details`) the supplied `children`.
 */
var FormElement = function (_a) {
    var inputId = _a.inputId, label = _a.label, subLabel = _a.subLabel, details = _a.details, isLabelHidden = _a.isLabelHidden, className = _a.className, children = _a.children, _b = _a.noBottomSpacing, noBottomSpacing = _b === void 0 ? false : _b;
    return (React.createElement("div", { className: className },
        label && (React.createElement(InputLabel, { className: c(s['label-wrapper'], isLabelHidden && s['hidden']), htmlFor: inputId, id: "".concat(inputId, "-label") }, label)),
        subLabel,
        children,
        details && React.createElement("div", { className: s['details-wrapper'] }, details),
        !details && !noBottomSpacing && (React.createElement("span", { className: s['extra-bottom-spacing'] }))));
};
FormElement.displayName = 'FormElement';
export default FormElement;
//# sourceMappingURL=FormElement.js.map